import { useQuery } from '@tanstack/react-query';
import { getPlatformClient } from '@/lib/api-clients';
import { queryKeys } from '@/lib/query-keys';

/**
 * Whether the person at the keyboard is VagusX staff signed in as this
 * practice — the only people who see and change the builder's VagusX-only
 * settings. The API enforces the same rule; this only decides what to show.
 *
 * Shares the impersonation banner's query, so it costs nothing extra. An org
 * user's whoami is refused, which reads here as "not ops".
 */
export function useOpsMode(): boolean {
  const { data } = useQuery({
    queryKey: queryKeys.platform.whoami(),
    queryFn: ({ signal }) => getPlatformClient().whoami(signal),
    retry: false,
    throwOnError: false,
    staleTime: 60_000,
    meta: { suppressGlobalError: true },
  });
  return data?.impersonating === true;
}
